var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useMemo } from 'react';
import useToggle from '../useToggle';
export default function useBoolean(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _a = __read(useToggle(defaultValue), 2),
      state = _a[0],
      toggle = _a[1].toggle;

  var actions = useMemo(function () {
    var setTrue = function setTrue() {
      return toggle(true);
    };

    var setFalse = function setFalse() {
      return toggle(false);
    };

    return {
      toggle: toggle,
      setTrue: setTrue,
      setFalse: setFalse
    };
  }, [toggle]);
  return [state, actions];
}


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useBoolean/index.js
// module id = 955
// module chunks = 2